/**
 * Labstep - UI Plugin State Hook
 *
 * Hook for managing UI plugin state
 */

import { useEffect, useState } from 'react';

export function useUIPluginState<T>(
  onUpdate: (callback: (state: T) => void) => () => void,
): T | null {
  const [state, setState] = useState<T | null>(null);

  useEffect(() => {
    const unsubscribe = onUpdate((newState: T) => {
      setState(newState);
    });

    return unsubscribe;
  }, [onUpdate]);

  return state;
}
